import { Partial } from '@40seas/entities/common';
import { CreateAirwallexRecipientDto } from './create.airwallex-recipient.dto';

export class UpdateAirwallexRecipientDto extends Partial(CreateAirwallexRecipientDto) {}
